module.exports = __webpack_public_path__ + "media/application/images/shop-2bccf2cbe59d7254c84466cdeb82b605.jpg";